/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "./config";

export default function EmployeeSalary() {
  const now = new Date();
  const [selectedMonth, setMonth] = useState(
    `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`
  );
  const [driverId, setDriverId]   = useState("");
  const [salaryData, setSalary]   = useState(null);
  const [allSalaries, setAll]     = useState([]);
  const [loading, setLoading]     = useState(false);
  const [search, setSearch]       = useState("");

  const fetchAllSalaries = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/advance/payout/all/${selectedMonth}`);
      setAll(res.data || []);
    } catch (e) { setAll([]); }
    setLoading(false);
  };

  const fetchSingle = async () => {
    if (!driverId.trim()) return;
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/advance/payout/${driverId.trim()}/${selectedMonth}`);
      setSalary(res.data || null);
    } catch (e) { setSalary(null); alert("No data for this driver/month"); }
    setLoading(false);
  };

  useEffect(() => { fetchAllSalaries(); }, [selectedMonth]);

  const handleApprove = async (dId) => {
    try {
      await axios.get(`${API_BASE_URL}/payment/approve/${dId}/${selectedMonth}`);
      alert("Payout approved!"); fetchAllSalaries();
    } catch (e) { alert("Approval failed"); }
  };

  const filtered = allSalaries.filter(r =>
    (r.driverId || "").toLowerCase().includes(search.toLowerCase()) ||
    (r.driverName || "").toLowerCase().includes(search.toLowerCase())
  );

  const S = {
    container:  { fontFamily: "Arial, sans-serif", marginLeft: "270px", marginRight: "10px", backgroundColor: "#fff", color: "#000", minHeight: "100%", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
    toolbar:    { display: "flex", gap: 10, alignItems: "center", padding: "14px 16px", flexWrap: "wrap" },
    input:      { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13 },
    btnYellow:  { background: "#FFC107", color: "#000", border: "none", padding: "8px 16px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    btnBlack:   { background: "#000", color: "#fff", border: "none", padding: "8px 16px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    table:      { width: "100%", borderCollapse: "collapse", marginBottom: 24 },
    thB:        { background: "#000", color: "#fff", padding: "14px 12px", textAlign: "center", fontSize: 13, fontWeight: "bold" },
    td:         { border: "1px solid #ccc", padding: "10px 12px", textAlign: "center", fontSize: 13, color: "#000" },
    statCard:   { background: "#fff", border: "1px solid #000", borderRadius: 8, padding: "16px 20px", textAlign: "center", minWidth: 130 },
    statVal:    { fontSize: 22, fontWeight: "bold", color: "#FFC107" },
    statLbl:    { fontSize: 11, color: "#555", marginTop: 4 },
    statRow:    { display: "flex", gap: 12, flexWrap: "wrap", padding: "0 16px 16px" },
    sectionLbl: { fontWeight: "bold", fontSize: 14, padding: "16px 16px 8px" },
  };

  return (
    <div style={S.container}>
      <h2 className="sendo-heading">Employee Salary</h2>

      {/* Month selector + search single driver */}
      <div style={S.toolbar}>
        <input
          style={S.input}
          type="month"
          value={selectedMonth}
          onChange={e => setMonth(e.target.value)}
        />
        <input
          style={{ ...S.input, width: 160 }}
          placeholder="Driver ID for detail..."
          value={driverId}
          onChange={e => setDriverId(e.target.value)}
        />
        <button style={S.btnYellow} onClick={fetchSingle}>🔍 Load Driver</button>
        <input style={S.input} placeholder="Search all..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      {/* Single driver detail */}
      {salaryData && (
        <div style={{ padding: "0 16px 16px" }}>
          <div style={S.sectionLbl}>Salary Summary — {salaryData.driverName || driverId} ({selectedMonth})</div>
          <div style={S.statRow}>
            {[
              { lbl: "Salary Month",    val: salaryData.salaryMonth    || selectedMonth },
              { lbl: "Driver ID",       val: salaryData.driverId       || driverId },
              { lbl: "No. of Days",     val: salaryData.noOfDays       || "—" },
              { lbl: "Basic Payment",   val: `₹${salaryData.basicPayment   || 0}` },
              { lbl: "Per Day",         val: `₹${salaryData.perDayPayment  || 0}` },
              { lbl: "Total Advance",   val: `₹${salaryData.totalAdvance   || 0}` },
              { lbl: "Total Deduction", val: `₹${salaryData.totalDeduction || 0}` },
              { lbl: "Net Payout",      val: `₹${salaryData.netPayout      || 0}` },
            ].map(c => (
              <div key={c.lbl} style={S.statCard}>
                <div style={S.statVal}>{c.val}</div>
                <div style={S.statLbl}>{c.lbl}</div>
              </div>
            ))}
          </div>
          <button style={{ ...S.btnYellow, marginLeft: 16 }}
            onClick={() => handleApprove(salaryData.driverId || driverId)}>
            ✅ Approve Payout
          </button>
        </div>
      )}

      {/* All salaries table */}
      <div style={S.sectionLbl}>All Employees — {selectedMonth} ({filtered.length})</div>
      {loading ? (
        <p style={{ padding: 20 }}>Loading salary data...</p>
      ) : filtered.length === 0 ? (
        <p style={{ padding: "0 16px", color: "#888", fontSize: 13 }}>No salary data for this month.</p>
      ) : (
        <div style={{ overflowX: "auto", padding: "0 16px" }}>
          <table style={S.table}>
            <thead>
              <tr>
                {["Driver ID","Name","Days","Basic Pay","Per Day","Total Advance","Total Deduction","Net Payout","Action"].map(h => (
                  <th key={h} style={S.thB}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((r, i) => (
                <tr key={r._id || r.driverId} style={{ background: i % 2 === 0 ? "#fff" : "#f9f9f9" }}>
                  <td style={S.td}>{r.driverId}</td>
                  <td style={S.td}>{r.driverName}</td>
                  <td style={S.td}>{r.noOfDays}</td>
                  <td style={S.td}>₹{r.basicPayment || 0}</td>
                  <td style={S.td}>₹{r.perDayPayment || 0}</td>
                  <td style={S.td}>₹{r.totalAdvance || 0}</td>
                  <td style={S.td}>₹{r.totalDeduction || 0}</td>
                  <td style={S.td}><strong>₹{r.netPayout || 0}</strong></td>
                  <td style={S.td}>
                    <button style={{ ...S.btnYellow, padding: "5px 10px" }} onClick={() => handleApprove(r.driverId)}>
                      Approve
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
